import { defineComponent as _defineComponent } from 'vue'
import { ActionBarButton } from './types/ActionBarComponentTypes'
import LfCustomContextMenu from '@/components/CustomContextMenu/LfCustomContextMenu.vue'
import LfLabelButtonComponent from '@/components/forms/buttons/label/LfLabelButtonComponent.vue'
import { LabelButtonVariant } from '@/components/forms/buttons/types/ButtonTypes'
import { PropType, computed, ref } from 'vue'
import { TrackerEvents, trackEvent } from '@/plugins/tracker'
import store from '@/store/store'
import { ModuleNamespaces } from '@/store/types/storeGlobalTypes'


export default /*#__PURE__*/_defineComponent({
  __name: 'LfActionsBarComponent',
  props: {
  buttons: {
    type: Array as PropType<ActionBarButton[]>,
    required: true
  },
  showKebabMenu: {
    type: Boolean as PropType<boolean>,
    default: true
  }
},
  emits: ['execute-action'],
  setup(__props, { emit }) {

const props = __props;

const menuParentCategoryName = computed(() => store.getters[`${ModuleNamespaces.ENTITIES}/getMenuParentCategoryName`])

// PROPS


// DATA
const disabledButtons = ref(false)
const timeout = ref(0)

// COMPUTED
const saveButtonIndex = computed(() => props.buttons.length - 1)

const customContextMenuButtons = computed(() =>
  props.buttons.filter((button: ActionBarButton) => button.isContextMenuOption)
)

// EVENTS


// METHODS
function onKebabOpened() {
  trackEvent(TrackerEvents.KEBAB_OPENED, { origin: menuParentCategoryName.value })
}

function executeActionKebab(action: string, index: number) {
  trackEvent(TrackerEvents.KEBAB_OPTION_SELECTED, { origin: action })
  executeAction(action, index)
}

function executeAction(action: string, index: number) {
  disabledButtons.value = true

  if (saveButtonIndex.value === index) {
    timeout.value = 4000
  } else {
    timeout.value = 1000
  }

  setTimeout(() => {
    disabledButtons.value = false
  }, timeout.value)

  emit('execute-action', action)
}

return { __sfc: true,menuParentCategoryName, props, disabledButtons, timeout, saveButtonIndex, customContextMenuButtons, emit, onKebabOpened, executeActionKebab, executeAction, LfCustomContextMenu, LfLabelButtonComponent, LabelButtonVariant }
}

})